import MobilePlans from './MobilePlans.vue'

export default MobilePlans
